<div class="otp-dialog__backdrop">
  <div
    class="otp-dialog__dialog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="otp-dialog-title"
    aria-describedby="otp-dialog-description"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    (keydown.escape)="onEscape()"
  >
    <div class="otp-dialog__icon-tile">
      <mat-icon aria-hidden="true">shield</mat-icon>
    </div>

    <h2 class="otp-dialog__title" id="otp-dialog-title">{{ 'login.otp.title' | translate }}</h2>
    <p class="otp-dialog__description" id="otp-dialog-description">
      {{ 'login.otp.descriptionBefore' | translate }}
      <span class="otp-dialog__email">{{ email() }}</span>
      {{ 'login.otp.descriptionAfter' | translate }}
    </p>

    <div class="otp-dialog__fields" (paste)="onPaste($event)">
      @for (digit of digits(); track $index) {
        <input
          #digitInput
          class="otp-dialog__digit"
          [class.otp-dialog__digit--filled]="digit && !errorMessage()"
          [class.otp-dialog__digit--error]="errorMessage()"
          type="text"
          inputmode="numeric"
          maxlength="1"
          autocomplete="one-time-code"
          [value]="digit"
          [attr.aria-label]="'login.otp.digitAriaLabel' | translate: { position: $index + 1 }"
          (input)="onDigitInput($index, $event)"
          (keydown)="onDigitKeydown($index, $event)"
        />
      }
    </div>

    @if (errorMessage(); as error) {
      <div class="otp-dialog__error" role="alert">
        <mat-icon aria-hidden="true">close</mat-icon>
        <span>{{ error }}</span>
      </div>
    }

    <button type="button" class="otp-dialog__submit" [disabled]="!canSubmit()" (click)="onSubmit()">
      {{ 'login.otp.submitButton' | translate }}
    </button>

    <div class="otp-dialog__footer" [class.otp-dialog__footer--resend-only]="!allowEmailChange()">
      @if (allowEmailChange()) {
        <button type="button" class="otp-dialog__change-email" (click)="onChangeEmailClick()">
          {{ 'login.otp.changeEmail' | translate }}
        </button>
      }
      <button
        type="button"
        class="otp-dialog__resend"
        [class.otp-dialog__resend--sent]="justResent()"
        [disabled]="resendDisabled()"
        aria-live="polite"
        aria-atomic="true"
        (click)="onResendClick()"
      >
        @if (justResent()) {
          {{ 'login.otp.resendSent' | translate }}
        } @else if (cooldownSeconds() > 0) {
          {{ 'login.otp.resend' | translate }} ({{ cooldownSeconds() }}s)
        } @else {
          {{ 'login.otp.resend' | translate }}
        }
      </button>
    </div>
  </div>
</div>
